// extracted by mini-css-extract-plugin
export default {"section":"PublicDashboardsFilters_section__GPeWi","inputs-container":"PublicDashboardsFilters_inputs-container__gD2W6"};